import { render, staticRenderFns } from "./login_up.vue?vue&type=template&id=63ce9722&scoped=true&"
import script from "./login_up.vue?vue&type=script&lang=js&"
export * from "./login_up.vue?vue&type=script&lang=js&"
import style0 from "./login_up.vue?vue&type=style&index=0&id=63ce9722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce9722",
  null
  
)

export default component.exports